import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=74289ed4&scoped=true"
import script from "./Office.vue?vue&type=script&lang=js"
export * from "./Office.vue?vue&type=script&lang=js"
import style0 from "./Office.vue?vue&type=style&index=0&id=74289ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74289ed4",
  null
  
)

export default component.exports